export const NAVIGATION = {
  name: 'Fragebogen',
  icon: 'fa-id-card-o',
  path: '/module/questionnaire/',
  children: [{
    name: 'Editor',
    path: '/module/questionnaire/editor',
    icon: 'fa-pencil'
  }]
};
